import script from "./SideBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBar.vue?vue&type=script&setup=true&lang=ts"

import "./SideBar.vue?vue&type=style&index=0&id=016cdfe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-016cdfe6"]])

export default __exports__